import React, { useEffect, useState } from "react";
import AnimatedDialogLayout from "./AnimatedDialogLayout";
import ButtonSpinner from "components/Loading/ButtonSpinner";
import useBookmark from "hooks/useBookmark";

const PropertyNoteDialog = ({ id, onClick, loading, defaultText }) => {
  const { isPropertyNoteDialogOpen, togglePropertyNoteDialog } = useBookmark();
  const [propertyNote, setPropertyNote] = useState("");

  const handleSaveNote = () => {
    onClick(propertyNote);
  };

  useEffect(() => {
    if (defaultText) {
      setPropertyNote(defaultText);
    }
  }, [defaultText]);

  return (
    <AnimatedDialogLayout
      isOpen={isPropertyNoteDialogOpen === id}
      onClose={() => togglePropertyNoteDialog(id)}
    >
      <div className="max-w-lg w-full xs:w-[430px] sm:w-[500px]">
        <h1 className="text-black font-semibold text-[18px] text-center leading-[21.78px]">
          Nota
        </h1>
        <textarea
          value={propertyNote}
          onChange={(e) => setPropertyNote(e.target.value)}
          type="text"
          rows={10}
          cols={10}
          placeholder="Scrivi qualcosa..."
          className="outline-none bg-transparent mt-[11px] border border-[#D1D1D1] rounded-[11px] min-h-[150px] max-h-[316px] w-full text-[16px] font-medium placeholder:text-[#949494] p-[15px]"
        />

        <button
          onClick={handleSaveNote}
          disabled={loading}
          className={`bg-primary mt-5 disabled:cursor-not-allowed text-white rounded-[11px] h-[51px] w-full grid justify-center items-center font-semibold text-[18px]`}
        >
          {loading ? <ButtonSpinner /> : "Salva Nota"}
        </button>
      </div>
    </AnimatedDialogLayout>
  );
};

export default PropertyNoteDialog;
